export const apiTranslate = process.env.REACT_APP_API_TRANSLATE;
export const api = process.env.REACT_APP_API;

export const TranslationContexts = {
  classificators: "BBS.Classificators",
  KYCOnBoarding: "BBS.Digital"
};

export const aPIPaths = {
  //Translations
  get_Translations: "/Translations/",
  get_Translations_CreateTranslation: "/Translations/GetCreateTranslation/",

  //KYC
  post_sendKycApplication: "/Kyc/KycApplication/",
  post_getListKYC: "/Kyc/AllKyc/",
  post_modifyKycApplication: "/Kyc/ModifyKyc/",
  post_approveKycApplication: "/Kyc/Approve/",
  delete_deleteKycApplication: "/Kyc/DeleteKyc/",
  startKYC: "/Kyc/StartKyc/",
  uploadPowerOfAttorney: "/Kyc/UploadPowerOfAttorney/",
  uploadOrganizationalChart: "/Kyc/uploadOrganizationalChart/",
  uploadArticlesOfAssociation: "/Kyc/UploadArticlesOfAssociation/",
  uploadApplicationDocument: "/Kyc/UploadApplicationDocument/{applicationDocumentId}",
  uploadBeneficiaryDocuments: "/Kyc/UploadBeneficiaryDocuments/",
  uploadWolfsbergQuestionnaire: "/Kyc/UploadWolfsbergQuestionnaire/",
  submitApplication: "/Kyc/SubmitApplication/",
  startApplicationSigning: "/Kyc/StartApplicationSigning/",
  startApplicationSignedUpload: "/Kyc/StartApplicationSignedUpload",
  uploadSignedApplication: "/Kyc/UploadSignedApplication/{applicationDocumentId}",
  checkSigningSca: "/Kyc/CheckSigningSca/",
  cancelSigning: "/Kyc/CancelSigning/",
  cancelUploadDocument: "Kyc/CancelUploadDocument",
  uploadSignedAgreement: "Kyc/UploadSignedAgreement/{applicationDocumentId}",
  resetAll: "/Kyc​/StartOver/",
  continueApplication: "/Kyc/Continue/",
  getCompanyClassification: "/Kyc/GetCompanyClassification/{companyType}/{institutionalSectorCode}/{naceCode}",
  checkState: "/Kyc/ApplicationState/",
  startAgreementSigning: "/Kyc/StartAgreementSigning/",
  uploadAdditionalDocuments: "/Kyc/UploadAdditionalDocuments/",
  startOndatoBeneficiaryIdentification: "/Kyc/StartOndatoBeneficiaryIdentification/",
  renderPdfFromHtml: "/Kyc/RenderPdfFromHtml",
  uploadKycPdf: "/Kyc/UploadKycPdf",
  validateData: "Kyc/ValidateData",
  institutionalCodeMap: "Kyc/InstitutionalCodeMap/{legalForm}/{nace}",

  //OnBoarding
  post_GenerateMarkIdPayload: "/Onboarding/GenerateMarkIdPayload/",
  post_OndatoStartIdentification: "/OnBoarding/OndatoStartIdentification/",

  //Tools
  get_companyNames: "/Tools/GetCompanyNames/",

  //Authorization
  startLogin: "/Authorization/StartLogin/",
  checkSca: "/Authorization/CheckSca/",
  selectIdentification: "/Authorization/SelectIdentification/",
  getIdentificationUrl: "/Authorization/GetIdentificationUrl/",
  refreshToken: "/Authorization/Refresh/", //{refreshToken}

  //Applications
  getApplicationList: "/Applications/",
  getManualAmlRiskList: "/Applications/GetManualAmlRisksList",
  calculateAllClientsRiskCraScreen: "/Applications/CalculateAllClientsRiskCraScreen",
  setManualAmlRiskList: "/Applications/{applicationId}/SetManualRisk",
  getSanctionsList: "/Applications/{applicationId}/Sanctions/",
  reviewSanction: "/Applications/{applicationId}/ReviewSanction/",
  allSanctionReviewed: "/Applications/{applicationId}/AllSanctionsReviewed/", // statusas i -> SetManualRisk
  getDocuments: "/Applications/{applicationId}/Documents/",
  getUploadedDocumentsList: "/Application/{applicationId}/Documents",
  getApplication: "/Applications/{applicationId}/",
  rejectApplication: "/Applications/{applicationId}/RejectApplication/",
  rejectDueSanctionList: "/Applications/{applicationId}/RejectDueSanctionList/",
  requestAdditionalDocuments: "/Applications/{applicationId}/RequestAdditionalDocuments/",
  approveRisk: "/Applications/{applicationId}/ApproveRisks/",
  addRisk: "/Applications/{applicationId}/AddRisk/",
  approveBeneficiaries: "/Applications/{applicationId}/ApproveBeneficiaries/",
  renewKyc: '/Admin/Application/{applicationId}/RenewKyc',
  retryPrefill: '/Admin/Application/{applicationId}/RetryPrefill',
  ///TODO Form save
  getApplicationDraft: "/Kyc/GetApplicationDraft/",
  postSaveApplicationDraft: "/Kyc/SaveApplicationDraft/",
  //TODO upload documents
  uploadDocuments: "/Applications/{applicationId}/UploadAdditionalDocuments/{documentType}/",
  setReviewKycStatus: "/Applications/{applicationId}/ReviewedKyc",
  setMissingDocuments: "/Applications/{applicationId}/ReviewedApplicationDocuments",
  confirmUploadedAgreements: "/Applications/{applicationId}/ConfirmingUploadedAgreement",
  rejectUploadedAgreement: "/Applications/{applicationId}/RejectUploadedAgreement",
  getClientRisksList: "/Applications/{applicationId}/GetClientRisksList",
  updateRiskHit: "/Applications/{applicationId}/UpdateRiskHit",

  // config
  countryRiskList: "/Config/CountryRiskList",
  updateCountryRisk: "/Config/UpdateCountryRisk",
  riskList: "/Config/RiskList",
  updateRiskItem: "/Config/UpdateRiskItem",
  naceBlockers: "/Config/NaceBlockers",
  updateNaceBlockersItem: "/Config/UpdateNaceBlockerItem"
};

export const apiIdentity = "https://test.identity.bbservice.lt/api/";
